import { EngageLibraryItemType, EngageLibraryItemTypeEnum } from './engage-library-types';
import { engageLibraryTabId } from './engage-library-utils';
import styles from './EngageLibraryTypeTabs.module.css';

interface EngageLibraryTypeTabsProps {
  value: EngageLibraryItemType;
  panelId: string;
  onChange: (value: EngageLibraryItemType) => void;
}

const TABS: { value: EngageLibraryItemType; label: string }[] = [
  { value: EngageLibraryItemTypeEnum.AUTOMATION, label: 'Automations' },
  { value: EngageLibraryItemTypeEnum.SEGMENT, label: 'Segments' },
];

export function EngageLibraryTypeTabs({ value, panelId, onChange }: EngageLibraryTypeTabsProps) {
  const selectTab = (index: number) => {
    const tab = TABS[index];
    onChange(tab.value);
    document.getElementById(engageLibraryTabId(panelId, tab.value))?.focus();
  };

  return (
    <div className={styles.segmented} role="tablist" aria-label="Library type">
      {TABS.map((tab, index) => (
        <button
          key={tab.value}
          id={engageLibraryTabId(panelId, tab.value)}
          type="button"
          role="tab"
          aria-selected={value === tab.value}
          aria-controls={panelId}
          tabIndex={value === tab.value ? 0 : -1}
          className={styles.segment}
          onClick={() => onChange(tab.value)}
          onKeyDown={event => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              selectTab((index - 1 + TABS.length) % TABS.length);
            } else if (event.key === 'ArrowRight') {
              event.preventDefault();
              selectTab((index + 1) % TABS.length);
            } else if (event.key === 'Home') {
              event.preventDefault();
              selectTab(0);
            } else if (event.key === 'End') {
              event.preventDefault();
              selectTab(TABS.length - 1);
            }
          }}>
          {tab.label}
        </button>
      ))}
    </div>
  );
}
